
import dialogMethods from 'src/mixins/dialogMethods'
export default {
  name: 'ActionSummary',

  mixins: [dialogMethods],

  props: {
    results: { type: Array, required: true },
  },
}
